import { Box, Stack, css } from '@mui/system';

import { AuthMenu } from './AuthMenu';
import { DesktopHeaderMenu } from './DesktopHeaderMenu';

type WebLayoutAppBarActionsProps = {
  strapiMenu?: boolean;
};

export const WebLayoutAppBarActions = ({
  strapiMenu,
}: WebLayoutAppBarActionsProps) => {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      {strapiMenu && (
        <DesktopHeaderMenu
          css={(theme) => css`
            display: none;

            ${theme.breakpoints.up('md')} {
              display: flex;
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
            }
          `}
        />
      )}

      <Box
        css={(theme) => css`
          margin-right: ${theme.breakpoints.down('md')
            ? '-12px !important'
            : 0};
          ${theme.breakpoints.down('md')} {
            display: none;
          }
        `}
      >
        <AuthMenu />
      </Box>
    </Stack>
  );
};
